import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin } from '../../../components/molecues';
import { Button, Table, Toast, LoadingView } from '../../../../common/components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';
import { Audio } from '../../../components/molecues';

import { ERROR_MESSAGE } from '../../../common/constants.js';
import { PopupMessage, POPUP_TYPE } from '../../../common/PopupMessage';

class CommentEdit extends Component {
    constructor(props) {
        super(props);

        this.refAudio = React.createRef();
        this.refToast = React.createRef();
        this.record = [{
            id: this.props.recordEdit ? this.props.recordEdit.id : "",
            userID: this.props.recordEdit ? this.props.recordEdit.userID : "",
            submitDate: this.props.recordEdit ? this.props.recordEdit.sendDatetime ? this.props.recordEdit.sendDatetime:this.props.recordEdit.submitDate : "",
            sendDatetime: this.props.recordEdit ? this.props.recordEdit.sendDatetime : "",
            title: this.props.recordEdit ? this.props.recordEdit.title : "",
            sendCount: this.props.recordEdit ? this.props.recordEdit.sendCount : "",
            status: this.props.recordEdit ? this.props.recordEdit.status : "",
            charge: this.props.recordEdit ? this.props.recordEdit.charge : "",
            commentDate: this.props.recordEdit ? this.props.recordEdit.commentDate : "",
            feedbackDate: this.props.recordEdit ? this.props.recordEdit.feedbackDate : "",
            audio: this.props.recordEdit ? this.props.recordEdit.audio : "",
            play: this.props.recordEdit ? this.props.recordEdit.play : 0,
            audioData: "",
        }];
        this.state = {
            comment: this.props.recordEdit ? this.props.recordEdit.comment : "",
            cancel: "0",
            displayDlg: false,
            audioPlay: false,
        }
    }
    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: "DownloadAudio_Saga",
            id: this.record[0].id,
            name: this.record[0].audio,
            mode: 1,
            onSuccess: this.onSuccessAudio,
            onFailure: this.onFailureAudio,
        });
    }
    onSuccessAudio = (audio, id) => {
        if (audio.indexOf("audio/x-m4a") !== -1) {
            this.refAudio.current.setWebm();
        }
        this.record[0].audioData = audio;
        this.props.dispatch({
            type: "LoadEnd"
        });
    }
    onFailureAudio = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onSuccess = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.history.push('/admin/trainer/top');
    }
    onSuccessSaveSend = () => {
        this.props.dispatch({
            type: "SendComment_Saga",
            id: this.record[0].id,
            userID: this.record[0].userID,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        })
}
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onCilckSend = (e) => {
        let err = [];
        let syserr = [];
        if(this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if(this.state.comment === "") {
            err.push("コメント" + ERROR_MESSAGE["not_entered"]);
        }
        if(err.length === 0 && syserr.length === 0){
            this.setState({
                displayDlg: true,
            });
        } else {
            let message = [];
            for(let key in err) {
                message.push(
                    <div key={key}>
                        {err[key]}
                    </div>
                )
            }
            let errMessage;
            if(message.length > 0) {
                errMessage = PopupMessage({
                    type: POPUP_TYPE.INPUT_ERROR,
                    message: message
                });
            }
            message = [];
            for(let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            let syserrMessage;
            if(message.length > 0) {
                syserrMessage = PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                });
            }
            this.refToast.current.set(0,[
                syserrMessage,
                errMessage
            ]);
        }
    }
    onClickSave = (e) => {
        let err = [];
        if(this.props.permission === 0) {
            err.push(ERROR_MESSAGE["permission_denied"]);
        }
        if(err.length === 0){
            this.props.dispatch({
                type: "LoadStart"
            });
            this.props.dispatch({
                type: "SaveComment_Saga",
                id: this.record[0].id,
                comment: this.state.comment,
                cancelFlg: this.state.cancel,
                charge: this.props.user.nickname,
                onSuccess: this.onSuccess,
                onFailure: this.onFailure,
            });
        } else {
            let message = [];
            for(let key in err) {
                message.push(
                    <div key={key}>
                        {err[key]}
                    </div>
                )
            }
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                })
            );
        }
    }
    onClickCancel = (e) => {
        this.props.history.push('/admin/trainer/top');
    }

    onChange = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        });
    }

    onChangeCancel = (e) => {
        this.setState({ cancel: e.target.dataset.value });
    }

    onClickPlay = (index) => {
        if(this.state.audioPlay) {
            this.refAudio.current.pause();
            this.record[0].play = 0;
            this.setState({
                audioPlay: false,
            });
        } else {
            this.refAudio.current.play();
            this.record[0].play = 1;
            this.setState({
                audioPlay: true,
            });
        }
   }

    onEnded = () => {
        this.setState({
            audioPlay: false,
        });
        this.record[0].play = 0;
    }

    createTableProps() {
        const height = "auto";
        return {
            height: height,
            columns : {
                "ユーザーID": "userID",
                "依頼日時": "submitDate",
                "教材タイトル": "title",
                "依頼回数": "sendCount",
                "対応状況": "status",
                "対応トレーナー": "charge",
                "対応開始日": "commentDate",
                "送信完了日時": "feedbackDate",
            },
            data: this.record,
        };
    }

    onClickSendCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: "SaveComment_Saga",
            commentID: "",
            id: this.record[0].id,
            comment: this.state.comment,
            cancelFlg: this.state.cancel,
            charge: this.props.user.nickname,
            onSuccess: this.onSuccessSaveSend,
            onFailure: this.onFailure,
    });
        this.setState({
            displayDlg: false,
        });
    }

    onClickDlgCancel = () => {
        this.setState({
            displayDlg: false,
        });
    }

    createDlgProps = () => {
        return {
            display: this.state.displayDlg,
            contents: (
                <div style={{padding: "20px 0"}}>
                    この情報でユーザーに送信します。<br/>
                    よろしいですか？<br/>
                    <br/>
                    <span style={{fontSize: "10px"}}>
                    設定されたメールアドレスにメールが送信されます。
                    </span>
                </div>
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickSendCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }
    onChangePlaybackRate = (rate) => {
        this.props.dispatch({
            type: "PlaybackRate",
            playbackRate: rate
        });
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight-64-64) + "px";
        const propsHeader = {
            title: "コメント入力",
            history: this.props.history,
        }
        const propsToast = {
            timeout: 2000,
            bottom: "50px",
            right: "100px",
        };
        const propsTable = this.createTableProps();
        const propsDlg = this.createDlgProps();
        const propsAudio = {
            src: [this.record[0].audioData],
            play: 0,
            playbackRate: this.props.playbackRate,
            onChangePlaybackRate: this.onChangePlaybackRate,
        }

        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <ContentsWrap Width={width} Height={height}>
                    <Contents>
                        <Table {...propsTable} />
                    </Contents>
                    <AudioWrap>
                        <Audio ref={this.refAudio} {...propsAudio} />
                    </AudioWrap>
                    <Contents>
                        <MainTable>
                            <Row>
                                <Title>
                                    コメント
                                </Title>
                                <Data>
                                    <textarea style={{width: "450px", height: "250px"}} name="comment" value={this.state.comment}
                                                            onChange={this.onChange} />
                                </Data>
                            </Row>
                            <Row>
                                <Title>
                                    依頼回数消費
                                </Title>
                                <Data>
                                    <Group>
                                        <Radio Select={this.state.cancel === "0"} data-value="0" onClick={this.onChangeCancel}>する</Radio>
                                        <Radio Select={this.state.cancel === "1"} data-value="1" onClick={this.onChangeCancel}>しない</Radio>
                                    </Group>

                                </Data>
                            </Row>
                        </MainTable>
                    </Contents>
                </ContentsWrap>
                <Controls>
                    <Button 
                        Color="#0077FF" 
                        Width="130px"
                        onClick={this.onCilckSend}
                        icon={(<i className="fas fa-paper-plane" />)}
                        text="送信" />
                    <Button 
                        Color="#26CFA9" 
                        Width="130px"
                        onClick={this.onClickSave}
                        icon={(<i className="fas fa-file-download" />)}
                        text="保存して戻る" />
                    <Button 
                        Color="#888888" 
                        Width="130px"
                        onClick={this.onClickCancel}
                        text="キャンセル" />
                </Controls>
                <ModalDialog name="send-dialog" {...propsDlg} />
                <Toast ref={this.refToast} {...propsToast} />
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        permission: store.login.user.permission,
        recordEdit: store.recordEdit.record,
        loading: store.loading.loading,
        afterLoadMessage: store.loading.message,
        loadResult: store.loading.state,
        user: store.login.user,
        playbackRate: store.setting.playbackRate,
    }
};

const connectedCommentEdit = connect(mapStateToProps)(CommentEdit);
export { connectedCommentEdit as CommentEdit };

const Body = styled.div`
`;
const ContentsWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;;
    flex-direction: column;
    margin: auto;
    padding-top: 20px;
    width: 50%;
    width: ${props => props.Width};
    height: ${props => props.Height};
    overflow: hidden scroll;
`;
const Contents = styled.div`
`;

const MainTable = styled.div`
`;
const Row = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 5px 0;
`;
const Title = styled.div`
    background-color: #888;
    color: #fff;
    padding: 10px 20px;
    text-align: center;
    min-width: 100px;
    margin: 0 5px;
`;
const Data = styled.div`
    min-width: 300px;
    margin: 0 5px;
    color: #888;
    min-height: 38px;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    input {
        border: none;
        border-radius: 0;
        width: 90%;
    }
`;

const Controls = styled.div`
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
`;

const TableContrl = styled.div`
    cursor: pointer;
    padding: 0 2px;
    color: ${props => props.Color};
`;

const Group = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    div {
        border: 1px solid #888;
    }
    div:first-of-type {
        border-radius: 5px 0 0 5px;
        border-left: 1px solid #888;
    }
    div:nth-of-type(even) {
        border-left: none;
        border-right: none;
    }
    div:last-of-type {
        border-radius: 0 5px 5px 0;
        border-right: 1px solid #888;
    }
`;
const Radio = styled.div`
    color: ${props => props.Select ? "#fff" : "#888"};
    background-color: ${props => props.Select ? "#888" : "#fff"};
    padding: 5px 5px;
    cursor: pointer;
    min-width: 50px;
    text-align: center;
`;
const AudioWrap = styled.div`
    margin: 80px 0;
    display: flex;
    justify-content: center;
`;
